module.exports = __webpack_public_path__ + "img/243-canada.0672d51a.svg";